<template>

    <div v-if="this.showModalVisibilidad" id="panelayuda" class=" relative z-10" aria-labelledby="slide-over-title"
        role="dialog" aria-modal="true">

        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div class="fixed inset-0 overflow-hidden">
            <div class="absolute inset-0 overflow-hidden ">
                <div class="pointer-events-none fixed inset-y-0 right-0 flex  pl-0 max-w-[100%]">
                    <div class="pointer-events-auto  w-screen   max-w-3xl">
                        <div class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                            <div class="bg-indigo-700 py-6 px-4 sm:px-6">
                                <div class="flex items-center justify-between">
                                    <div class="">



                                    </div>




                                    <div className="grid grid-cols-1 grid-rows-1 gap-2 ml-2">

                                        <div class="pl-12">
                                            <h2 class="text-1xl font-bold tracking-tight text-white sm:text-4xl">
                                              {{ $t('calendario') }}
                                            </h2>
                                        </div>
                                    </div>



                                    <div>








                                    </div>


                                    <div class="ml-3 flex h-7 items-center">
                                        <button @click="close()" type="button"
                                            class="rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white ">
                                            <span class="sr-only">Close panel</span>
                                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                                stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M6 18L18 6M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div className="  m-5">





                                <h1 class="text-1xl font-extrabold text-left text-cyan-800">
                                    {{ $t('Seleccione fechas de consulta') }}
                                </h1>

                                <CalendarioLive :fechasSeleccionadas="fechasSeleccionadas"
                                    @getFecCalendar="getFecCalendar">
                                </CalendarioLive>


                                <div v-if="mostrarSpinner == true">
                                    <SpinnerLoading></SpinnerLoading>
                                </div>










                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarioLive from "../../calendar/CalendarioLive";



export default {
    emits: [
        "handleVisibilidad"
    ],
    components: {

        CalendarioLive,
    },
    props: {
        nomedificio: String,
        showModalVisibilidad: Boolean,
        objJaulas: Array,
        propIdFaena: String
    },
    methods: {
        close() {

            this.$emit("close")
        },

        restaDias(minus) {

            let hoy = this.$store.getters.fechaHoraActual(this.propIdFaena);

            let diaHoy = String(hoy.getDate).padStart(2, '0');
            let mesHoy = String(hoy.getMonth).padStart(2, '0');
            let añoHoy = String(hoy.getFullYear).padStart(2, '0');
            let fechaHoy = `${diaHoy} ${mesHoy} ${añoHoy}`;

            let fec = this.$store.getters.restarDias(diaHoy, mesHoy, añoHoy, minus,this.propIdFaena);
            let dd = String(fec.getDate).padStart(2, '0');
            let mm = String(fec.getMonth).padStart(2, '0');
            let aa = String(fec.getFullYear).padStart(2, '0');
            let fechaRestada = `${dd} ${mm} ${aa}`;
            return [fechaRestada, fechaHoy]
        },
        getFecCalendar(f) {
            this.$store.state.gotolive = false;
            this.startDate = this.convertirFormatoFecha(f[0]); //2023-11-01
            this.endDate = this.convertirFormatoFecha(f[1]);
            this.$emit("handleRangoFechas", {
                'startDate': this.startDate,
                'endDate': this.endDate
            });
        },
        convertirFormatoFecha(fechaOriginal) {
            if (!fechaOriginal) return false;
            const [dia, mes, año] = fechaOriginal.split(/\s+/);
            if (!dia || !mes || !año || año.length !== 4) return false;
            return  `${año}-${mes}-${dia}`;    
        },
    },
    data() {
        return {
            showPanel: Boolean,
            objVisibilidad: [],
            fechasSeleccionadas: [],

        }
    },
    created() {

        this.showPanel = this.showModalVisibilidad


    },
    mounted() {
        this.fechasSeleccionadas = this.restaDias(30)

    },
    

}
</script>